import { useState, useEffect } from 'react';

const PERMISSION_TABS = [
  { key: 'action', label: 'Action' },
  { key: 'field', label: 'Field' },
];

const RightContentActionPermissions = ({
  selectedOption,
  permissionByModule,
  sendDataToParent,
  permissionSubTab = 'action',
  onSubTabChange,
  onSave,
}) => {
  const [checkboxes, setCheckboxes] = useState({});
  const [modulePermission, setModulePermission] = useState(permissionByModule);

  let checkedPermissionIds = [];

  useEffect(() => {
    setModulePermission(permissionByModule);
  }, [permissionByModule]);

  useEffect(() => {
    if (selectedOption !== undefined && modulePermission) {
      const moduleData = modulePermission[selectedOption];
      setCheckboxes(moduleData?.[permissionSubTab] ?? {});
    }
  }, [selectedOption, modulePermission, permissionSubTab]);

  const handleCheckboxChange = (option, id) => {
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [option]: {
        id: id,
        ischecked: !prevCheckboxes[option].ischecked,
      },
    }));
    if (id !== undefined && !checkedPermissionIds.includes(id)) {
      checkedPermissionIds.push(id);
    }
    sendDataToParent(checkedPermissionIds);
  };

  const isEmpty = !checkboxes || Object.keys(checkboxes).length === 0;

  return (
    <div className="right-content">
      <h4 style={{ marginBottom: '9px' }}>{selectedOption}</h4>

      <div className="perm-tab-section">
        <div className="roleMgmt perm-tab-header">
          <ul className="nav nav-underline">
            {PERMISSION_TABS.map((tab) => (
              <li className="nav-item" key={tab.key}>
                <a
                  className={`nav-link${permissionSubTab === tab.key ? ' active' : ''}`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => onSubTabChange && onSubTabChange(tab.key)}
                >
                  {tab.label}
                </a>
              </li>
            ))}
          </ul>
          {onSave && (
            <button className="save-btn" onClick={onSave} style={{ float: 'none', marginBottom: 0, flexShrink: 0 }}>
              Save
            </button>
          )}
        </div>

        <div className="perm-groups-container">
        {isEmpty ? (
          <div className="permission-tab-empty">
            <i className="bi bi-shield-slash permission-tab-empty-icon" />
            <p>No {permissionSubTab} permissions for this module.</p>
          </div>
        ) : (
          <div className="row">
            {Object.entries(checkboxes).map(([option, data]) => (
              <div key={option} className="col-12 col-sm-12 col-md-6 col-lg-6">
                <div className="checkbox-item">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <input
                      className="checkbox-name"
                      type="checkbox"
                      id={data.id}
                      checked={data.ischecked}
                      onChange={() => handleCheckboxChange(option, data.id)}
                    />
                    <label className="label" htmlFor={String(data.id)}>
                      {data.displayName || option}
                    </label>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default RightContentActionPermissions;
